export default {
  index: [
    {
      path: '/tearecharge',
      component: resolve => require(['./tearechargeIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/tearecharge/_router.js